export default __webpack_public_path__ + "static/media/chevronLarge.48d264c9.svg";